import React, { useRef } from 'react';
import { Box, Wrap, WrapItem } from '@chakra-ui/react';
import tags from '../data/tags.json';

const GROUP_COLORS = {
  'Ancient Indian History': { text: '#ffd54f', bg: 'rgba(255,213,79,0.07)',  border: 'rgba(255,213,79,0.22)',  selected: '#ffd54f' },
  'Indian Mythology':       { text: '#ef8660', bg: 'rgba(239,134,96,0.07)',  border: 'rgba(239,134,96,0.22)',  selected: '#ef8660' },
  'Concept of Time':        { text: '#ffca28', bg: 'rgba(255,202,40,0.07)',  border: 'rgba(255,202,40,0.22)',  selected: '#ffca28' },
  'Varanasi Series':        { text: 'rgba(255,255,255,0.65)', bg: 'rgba(255,255,255,0.04)', border: 'rgba(255,255,255,0.15)', selected: 'rgba(255,255,255,0.85)' },
  'Sacred Spaces':          { text: 'rgba(255,255,255,0.65)', bg: 'rgba(255,255,255,0.04)', border: 'rgba(255,255,255,0.15)', selected: 'rgba(255,255,255,0.85)' },
  'Format':                 { text: 'rgba(255,255,255,0.65)', bg: 'rgba(255,255,255,0.04)', border: 'rgba(255,255,255,0.15)', selected: 'rgba(255,255,255,0.85)' },
};

const FALLBACK = { text: '#ff9800', bg: 'rgba(255,152,0,0.07)', border: 'rgba(255,152,0,0.22)', selected: '#ff9800' };

const TagPill = ({ tag, isSelected, onTagSelect }) => {
  const c = GROUP_COLORS[tag.group] || FALLBACK;
  const pillRef = useRef(null);

  const handleClick = (e) => {
    const btn = pillRef.current;
    if (!btn) { onTagSelect(tag.id); return; }
    const rect = btn.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const ripple = document.createElement('span');
    const size = Math.max(rect.width, rect.height) * 1.8;
    ripple.style.cssText = `
      position:absolute;
      border-radius:50%;
      width:${size}px;height:${size}px;
      left:${x - size / 2}px;top:${y - size / 2}px;
      background:${isSelected ? 'rgba(21,13,4,0.25)' : c.selected};
      opacity:0.35;
      transform:scale(0);
      animation:ripple-burst 0.5s ease-out forwards;
      pointer-events:none;
    `;
    btn.appendChild(ripple);
    ripple.addEventListener('animationend', () => ripple.remove());
    onTagSelect(tag.id);
  };

  return (
    <Box
      ref={pillRef}
      as="button"
      onClick={handleClick}
      px={3}
      py={1.5}
      borderRadius="full"
      fontSize={{ base: 'xs', md: 'sm' }}
      fontWeight={isSelected ? 'semibold' : 'normal'}
      color={isSelected ? '#150d04' : c.text}
      bg={isSelected ? c.selected : c.bg}
      border="1px solid"
      borderColor={isSelected ? c.selected : c.border}
      boxShadow={isSelected ? `0 0 14px ${c.selected}55` : 'none'}
      transition="all 0.2s"
      position="relative"
      overflow="hidden"
      _hover={{
        bg: isSelected ? c.selected : c.bg.replace('0.07', '0.14').replace('0.08', '0.15'),
        borderColor: c.selected,
        transform: 'translateY(-1px)',
      }}
    >
      {tag.name}
    </Box>
  );
};

const TagFilter = ({ selectedTags, onTagSelect, onClear }) => {
  return (
    <Box>
      <Wrap spacing={2}>
        {tags.map((tag) => (
          <WrapItem key={tag.id}>
            <TagPill
              tag={tag}
              isSelected={selectedTags.includes(tag.id)}
              onTagSelect={onTagSelect}
            />
          </WrapItem>
        ))}
      </Wrap>

      {selectedTags.length > 0 && onClear && (
        <Box textAlign="right" mt={2}>
          <Box
            as="button"
            onClick={onClear}
            fontSize="xs"
            color="whiteAlpha.500"
            _hover={{ color: 'brand.400' }}
            transition="color 0.15s"
          >
            Clear filters
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default TagFilter;
